module.exports = __webpack_public_path__ + "img/蛹虫草.6d23b35b.jpg";